import { atom } from 'jotai';

import { itemPositionsQueryAtom } from '../_graphql/queryItemPositions';
import {
  ItemPositionSortOption,
  enumItemPositionSortOption,
} from '../types/position';

import { atomFromQueryString } from '~/shared/state';

// URL-synced params
export const $searchTerm = atomFromQueryString.string('q');
export const $selectedFacility = atomFromQueryString.string('f');
export const $showOnlyNegative = atomFromQueryString.boolean('negative', false);
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);

// Plain atoms
export const $currentSorting = atom<ItemPositionSortOption[]>([
  enumItemPositionSortOption.NetPositionAsc,
]);

// Remote data
export const $remotePositions = itemPositionsQueryAtom((get) => {
  const searchTerm = get($searchTerm);
  const selectedFacility = get($selectedFacility);
  const showOnlyNegative = get($showOnlyNegative);
  const limit = get($limit);
  const offset = get($offset);
  const sorting = get($currentSorting);

  const params: {
    searchTerm?: string;
    facilityIds?: string[];
    showOnlyNegative?: boolean;
    limit: number;
    offset: number;
    sorting: ItemPositionSortOption[];
  } = {
    limit,
    offset,
    sorting,
  };

  if (searchTerm) params.searchTerm = searchTerm;
  if (selectedFacility && selectedFacility !== 'all') {
    params.facilityIds = [selectedFacility];
  }
  if (showOnlyNegative) {
    params.showOnlyNegative = showOnlyNegative;
  }

  return {
    variables: params,
  };
});
